enum ThemesEnum {
  EDUCATOR = "educator",
  STUDENT_K_2 = "student_k_2",
  STUDENT_3_5 = "student_3_5",
  STUDENT_6_8 = "student_6_8",
  STUDENT_9_12 = "student_9_12"
}
export default ThemesEnum;
